import React, { useState, useEffect } from "react";
import { Table, Card, Button, Spinner, Alert } from "react-bootstrap";
import { FaPrint, FaSync } from "react-icons/fa";
import api from "../../axiosConfig";

export default function RaportNecesarAprovizionare() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchData = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await api.get("/comenzi-prod/rapoarte/necesar-aprovizionare");
      setData(res.data);
    } catch (err) {
      console.error(err);
      setError("Eroare la încărcarea raportului.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4>Necesar de Aprovizionat (Comenzi Producție Active)</h4>
        <div>
          <Button variant="outline-secondary" className="me-2" onClick={fetchData} disabled={loading}>
            <FaSync className="me-1" /> Actualizează
          </Button>
          <Button variant="primary" onClick={handlePrint} className="d-print-none">
            <FaPrint className="me-1" /> Printează
          </Button>
        </div>
      </div>

      <Card className="shadow-sm border-0">
        <Card.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          
          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <div className="table-responsive">
              <Table bordered hover striped className="align-middle">
                <thead className="table-light">
                  <tr>
                    <th>Cod</th>
                    <th>Denumire Materie Primă</th>
                    <th className="text-end">Necesar Total (din Rețete)</th>
                    <th className="text-end">Deja Transferat (În Lucru)</th>
                    <th className="text-end text-danger fw-bold">Rest de Aprovizionat / Transferat</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center text-muted py-4">
                        Nu există necesar de materiale pentru comenzile active curente.
                      </td>
                    </tr>
                  ) : (
                    data.map((row, idx) => (
                      <tr key={idx}>
                        <td>{row.cod}</td>
                        <td className="fw-bold">{row.denumire}</td>
                        <td className="text-end">{Number(row.total_necesar).toFixed(2)}</td>
                        <td className="text-end text-success">{Number(row.total_transferat).toFixed(2)}</td>
                        <td className="text-end text-danger fw-bold">{Number(row.rest_de_transferat).toFixed(2)}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
          )}
        </Card.Body>
      </Card>
      
      <style>{`
        @media print {
          .d-print-none, .navbar, .sidebar { display: none !important; }
          body { background: white; padding: 0; margin: 0; }
          .container-fluid { padding: 0; }
          .card { border: none !important; box-shadow: none !important; }
        }
      `}</style>
    </div>
  );
}
